import {
  IsArray,
  IsNotEmpty,
  IsNumberString,
  IsString,
  IsUUID,
  Length,
} from 'class-validator';

import { t } from '@vk-hr-tek/core/translations';

import { UNEP_KONTUR_CODE_LENGTH } from '@app/constants';

const notEmptyOptions = {
  message: 'Обязательное поле',
};

export class AcceptConfirmPoliciesDto {
  @IsNotEmpty(notEmptyOptions)
  @IsUUID(undefined, { each: true })
  @IsArray()
  policyVersions: string[];

  @Length(UNEP_KONTUR_CODE_LENGTH, UNEP_KONTUR_CODE_LENGTH, {
    message: () => t('PopupSignUNEPKontur.Error.Code'),
    groups: ['form'],
  })
  @IsNumberString(
    {
      no_symbols: true,
    },
    {
      message: () => t('PopupSignUNEPKontur.Error.Code'),
      groups: ['form'],
    },
  )
  @IsNotEmpty({
    groups: ['form'],
    message: () => t('PopupSignUNEPKontur.Error.Empty'),
  })
  @IsString({
    groups: ['form'],
    message: () => t('PopupSignUNEPKontur.Error.Empty'),
  })
  code: string;
}
